module.exports = __webpack_public_path__ + "static/wejscie-ad96eb76e5ff19fe30d14431116aef2b.jpg";